import { render, staticRenderFns } from "./appr-table.vue?vue&type=template&id=741b35b7&scoped=true"
import script from "./appr-table.vue?vue&type=script&lang=js"
export * from "./appr-table.vue?vue&type=script&lang=js"
import style0 from "./appr-table.vue?vue&type=style&index=0&id=741b35b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741b35b7",
  null
  
)

export default component.exports